import { Component, OnInit } from '@angular/core';
import { RouterLink }          from '@angular/router';
import {environment} from "../../../environments/environment";

@Component({
    selector: 'subscription-confirmed',
    templateUrl: './subscription-confirmed.component.html'
})
export class SubscriptionConfirmedComponent implements OnInit {
    env = environment;

    constructor() { }

    ngOnInit() {
    }

}
